var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 0.1875C10.5703 0.351562 10.6172 0.703125 10.4531 0.960938L4.26562 9.58594C4.14844 9.72656 4.00781 9.79688 3.84375 9.82031C3.67969 9.82031 3.51562 9.77344 3.39844 9.65625L0.210938 6.46875C0 6.25781 0 5.88281 0.210938 5.67188C0.421875 5.46094 0.796875 5.46094 1.00781 5.67188L3.72656 8.39062L9.53906 0.304688C9.70312 0.046875 10.0547 0 10.3125 0.1875Z",
    fill: "#3A8659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.01d4f6effa8463f432103992938f71e3.svg";
export { ForwardRef as ReactComponent };